import { render } from "./SalesDeliveriesOperEditorPage.vue?vue&type=template&id=62bbb6e8&ts=true"
import script from "./SalesDeliveriesOperEditorPage.vue?vue&type=script&lang=ts"
export * from "./SalesDeliveriesOperEditorPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__